export default __webpack_public_path__ + "static/media/37.b2db9329.jpg";